import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS';
import getShowtime from '../../../functions/getShowtime';

const mapStateToProps = (state, ownProps) => ({
    locale: state.getIn(['translation', 'locale']),
    timezone: state.getIn(['translation', 'timezone']),
    debug: state.getIn(['translation', 'debug'])
})

const TranslationShowtime = ({string, locale, timezone, debug, before="", after=""}) => {
    return getShowtime(string, locale, timezone, debug, before, after)
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationShowtime)